import type {
  IAudio,
  IEpisode,
  TDownloadingAudio,
  TDownloadingVideo,
  TEpisode,
  TEpisodeBlob,
} from "@src/types/AppTypes";
import Dexie, { Table } from "dexie";

let db: MyMedia | null = null;

export class MyMedia extends Dexie {
  episodes!: Table<IEpisode & TEpisode>;
  musics!: Table<IAudio>;
  downloadingVideos!: Table<TDownloadingVideo>;
  downloadingMusics!: Table<TDownloadingAudio>;
  episodesBlobData!: Table<TEpisodeBlob>;
  musicBlobData!: Table<TEpisodeBlob>;

  constructor(name: string) {
    super(name);
    this.version(6)
      .stores({
        episodes:
          "id, blob, is_purchased, content_type, title, number_of_season, number_of_episode, total_duration, thumbnailBlob",
        musics:
          "id, blob, is_purchased, content_type, title, total_duration, thumbnailBlob, artists, release_date",
        downloadingVideos: "id, isDownloading, parts, type, end",
        downloadingMusics: "id, isDownloading, parts, type, end",
      })
      .upgrade(() => {
        db?.episodes?.clear();
        db?.musics?.clear();
        db?.downloadingMusics?.clear();
        db?.downloadingVideos?.clear();
      });
    this.version(7)
      .stores({
        episodes:
          "id, blob, is_purchased, content_type, title, number_of_season, number_of_episode, total_duration, thumbnailBlob",
        musics:
          "id, blob, is_purchased, content_type, title, total_duration, thumbnailBlob, artists, release_date",
        downloadingVideos: "id, isDownloading, progress, type, end",
        downloadingMusics: "id, isDownloading, progress, type, end",
        episodesBlobData: "++id, fileId, index, part",
        musicBlobData: "++id, fileId, index, part",
      })
      .upgrade(() => {
        db?.episodes?.clear();
        db?.musics?.clear();
        db?.downloadingMusics?.clear();
        db?.downloadingVideos?.clear();
        db?.episodesBlobData?.clear();
        db?.musicBlobData?.clear();
      });
    this.version(8)
      .stores({
        episodes:
          "id, slug, title, is_purchased, is_rented, full_episode, release_date, blob, content_type, number_of_season, number_of_episode, total_duration, thumbnailBlob",
        musics:
          "id, slug, title, bytesize, blob, is_purchased, content_type, total_duration, thumbnailBlob, artists, release_date",
        downloadingVideos:
          "id, isDownloading, progress, type, end, parts, tsUrls",
        downloadingMusics: "id, isDownloading, progress, type, end",
        episodesBlobData: "++id, fileId, index, part",
        musicBlobData: "++id, fileId, index, part",
      })
      .upgrade(() => {
        db?.episodes?.clear();
        db?.musics?.clear();
        db?.downloadingMusics?.clear();
        db?.downloadingVideos?.clear();
        db?.episodesBlobData?.clear();
        db?.musicBlobData?.clear();
      });
    this.version(9)
      .stores({
        episodes:
          "id, slug, title, is_purchased, is_rented, full_episode, release_date, blob, content_type, number_of_season, number_of_episode, total_duration, thumbnailBlob, tsUrls, timeUrls, downloaded, downloading",
        musics:
          "id, slug, title, bytesize, blob, is_purchased, content_type, total_duration, thumbnailBlob, artists, release_date",
        downloadingVideos:
          "id, isDownloading, progress, type, end, parts, tsUrls, timeUrls",
        downloadingMusics: "id, isDownloading, progress, type, end",
        episodesBlobData: "++id, fileId, index, part",
        musicBlobData: "++id, fileId, index, part",
      })
      .upgrade(() => {
        db?.episodes?.clear();
        db?.musics?.clear();
        db?.downloadingMusics?.clear();
        db?.downloadingVideos?.clear();
        db?.episodesBlobData?.clear();
        db?.musicBlobData?.clear();
      });
  }
}

export const getDb = () => {
  return db;
};

export const createDB = (dbName: string) => {
  db = new MyMedia(dbName);
};
